import storeHelpers from '@/utils/helpers/store';

import {
  addressMutation,
  isValidAddressForm,
  isValidElevator,
  isValidFurnitureTransportForm,
  isValidHousingForm,
  isValidParkingArea,
  isSpecialLogementType,
} from '../utils';
import { Connector } from '@/backendConnector';

const state = {
  isAddressKnown: null,
  delivery: {
    address: {
      city: '',
      country: '',
      postal: '',
      street: '',
    },
    floor: {
      all_in_lift: null,
      floor: '',
      lift: null,
      lift_comment: '',
      mm_obligatoire: null,
      mm_utilisable: null,
      stairs: null,
      type_logement: null,
      cave: null,
    },
    parking: {
      type: '',
      portage: '',
      vl: null,
    },
  },
};

const actions = {
  addressSaveState({ getters }) {
    if (!getters.isAddressKnown) {
      return Promise.all(
        [
          Connector.getInstance()
            .postDeliveryAddress({
              address: getters.address,
              floor: {
                all_in_lift: null,
                floor: '0',
                lift: false,
                lift_comment: null,
                mm_obligatoire: null,
                mm_utilisable: null,
                stairs: null,
                type_logement: getters.floor.type_logement,
                cave: 0,
              },
            }),
          Connector.getInstance()
            .deleteDeliveryParking(),
        ],
      );
    }
    return Connector.getInstance()
      .postDeliveryAddress({ address: getters.address });
  },
  housingSaveState({
    getters,
  }) {
    const promises = [
      Connector.getInstance()
        .postDeliveryAddress({ address: getters.address, floor: getters.floor }),
    ];
    if (isSpecialLogementType(getters.floor.type_logement)) {
      promises.push(Connector.getInstance().deleteDeliveryParking());
    }
    return Promise.all(promises);
  },
  furnitureTransportSaveState({
    getters,
  }) {
    return Connector.getInstance()
      .postDeliveryAddress({ floor: getters.floor });
  },
  parkingAreaSaveState({
    getters,
  }) {
    return Connector.getInstance()
      .postDeliveryParking(getters.parking);
  },
};
const getters = {
  ...storeHelpers.getGetters(state.delivery, 'delivery'),
  ...storeHelpers.getGetters(state.delivery.floor, 'delivery'),
  ...storeHelpers.getGetters(state.delivery.address, 'delivery'),
  ...storeHelpers.getGetters(state.delivery.parking, 'delivery'),
  address: state => state.delivery.address,
  delivery: state => state.delivery,
  isAddressKnown: state => state.isAddressKnown,
  'address/isValidForm': state => isValidAddressForm(state.delivery, state.isAddressKnown),
  'housing/isValidForm': state => isValidHousingForm(state.delivery),
  'elevator/isValidForm': state => isValidElevator(state.delivery),
  'furnitureTransport/isValidForm': state => isValidFurnitureTransportForm(state.delivery),
  'parkingArea/isValidForm': state => isValidParkingArea(state.delivery),
};

const mutations = {
  ...addressMutation('delivery'),
  SET_IS_KNOW_ADDRESS(state, isKnowAddress) {
    state.isAddressKnown = isKnowAddress;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
